import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import AirplayIcon from "@material-ui/icons/Airplay";
import HelpIcon from "@material-ui/icons/HelpOutline";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { languages } from "../../constants/languages";

const styles = (theme) => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
});

const PresentationMenu = (props) => (
  <div>
    <Button
      className={props.classes.button}
      aria-owns={props.open ? "menu-appbar" : null}
      aria-haspopup="true"
      onClick={props.handleMenu}
      color="inherit"
      style={{ color: "white" }}
    >
      <AirplayIcon style={{ height: 25, marginRight: 5 }} />
      <span className={props.classes.buttonText}>
        {languages.tournament.presentation}
      </span>
    </Button>
    <IconButton
      className={props.classes.iconButton}
      aria-owns={props.open ? "menu-appbar" : null}
      aria-haspopup="true"
      onClick={props.handleMenu}
      color="inherit"
      style={{ color: "white" }}
    >
      <AirplayIcon style={{ height: 25, marginRight: 5 }} />
    </IconButton>
    <Menu
      id="menu-appbar"
      anchorEl={props.anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={props.open}
      onClose={props.handleClose}
      style={{ zIndex: 1302 }}
    >
      {props.tournament.liveLink ? (
        <MenuItem style={!props.tournament.liveLink ? {} : { padding: 0 }}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={
              "https://" +
              (props.isPSDUser || props.tournament.crqpsd
                ? "tournify.prosoccerdata.com/"
                : "tournifyapp.com/live/") +
              props.tournament.liveLink
            }
            style={{
              color: "#000",
              textDecoration: "none",
              padding: "6px 16px",
              width: "100%",
            }}
          >
            {languages.tournament.publicWebsite}
          </a>
        </MenuItem>
      ) : (
        <Tooltip title={languages.tournament.noLiveLink}>
          <div>
            <MenuItem
              disabled
              style={!props.tournament.liveLink ? {} : { padding: 0 }}
            >
              {languages.tournament.publicWebsite}
              <HelpIcon style={{ height: 15, width: 15, marginLeft: 10 }} />
            </MenuItem>
          </div>
        </Tooltip>
      )}
      <MenuItem
        disabled={!props.tournament.liveLink}
        style={!props.tournament.liveLink ? {} : { padding: 0 }}
      >
        {props.tournament.liveLink ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={
              "https://" +
              (props.isPSDUser || props.tournament.crqpsd
                ? "tournify.prosoccerdata.com/"
                : "tournifyapp.com/live/") +
              props.tournament.liveLink +
              "/present"
            }
            style={{
              color: "#000",
              textDecoration: "none",
              padding: "6px 16px",
              width: "100%",
            }}
          >
            {props.tournament.slideshowName
              ? languages.tournament.slideShow +
                ": " +
                props.tournament.slideshowName
              : languages.tournament.slideShow +
                (props.slideshows.length > 0 ? " 1" : "")}
          </a>
        ) : props.tournament.slideshowName ? (
          languages.tournament.slideShow + ": " + props.tournament.slideshowName
        ) : (
          languages.tournament.slideShow +
          (props.slideshows.length > 0 ? " 1" : "")
        )}
      </MenuItem>
      {props.slideshows
        .sort((a, b) => a.id - b.id)
        .map((slideshow, i) => {
          return (
            <MenuItem
              key={i}
              disabled={!props.tournament.liveLink}
              style={!props.tournament.liveLink ? {} : { padding: 0 }}
            >
              {props.tournament.liveLink ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    "https://" +
                    (props.isPSDUser || props.tournament.crqpsd
                      ? "tournify.prosoccerdata.com/"
                      : "tournifyapp.com/live/") +
                    props.tournament.liveLink +
                    "/present/" +
                    (i + 2).toString()
                  }
                  style={{
                    color: "#000",
                    textDecoration: "none",
                    padding: "6px 16px",
                    width: "100%",
                  }}
                >
                  {slideshow.name
                    ? languages.tournament.slideShow + ": " + slideshow.name
                    : languages.tournament.slideShow + " " + (i + 2).toString()}
                </a>
              ) : slideshow.name ? (
                languages.tournament.slideShow + ": " + slideshow.name
              ) : (
                languages.tournament.slideShow + " " + (i + 2).toString()
              )}
            </MenuItem>
          );
        })}
      <MenuItem style={{ padding: 0 }}>
        <Link
          onClick={props.handleClose}
          to={"/tournament/" + props.tournament[".key"]}
          style={{
            color: "#000",
            textDecoration: "none",
            padding: "6px 16px",
            width: "100%",
          }}
        >
          {languages.tournament.settings}
        </Link>
      </MenuItem>
    </Menu>
  </div>
);

PresentationMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PresentationMenu);
